export default __webpack_public_path__ + "static/media/nfts_big.1d294f6e.jpg";